import React from 'react';
import { useRecoilState, useRecoilValue } from 'recoil';
import { IEmployee } from '../../lib/types';
import { filteredEmployeeSelector } from '../../recoil/employee-sort-filter';
import { employeePagingAtom } from '../../recoil/employee-paging';
import './employee-paging.scss';

export default function EmployeePaging(): JSX.Element {
   const backArrowSvg: URL = new URL(
      '/public/images/back-arrow.svg',
      import.meta.url
   );

   const employee: IEmployee[] = useRecoilValue(
      filteredEmployeeSelector
   );

   const [currentPage, setCurrentPage] = useRecoilState(employeePagingAtom);
   const nextPage = () => {
      if ((currentPage + 1) * 25 < employee.length) {
         setCurrentPage(currentPage + 1);
      }
   };
   const prevPage = () => {
      if (currentPage > 0) {
         setCurrentPage(currentPage - 1);
      }
   };
   const firstPage = () => {
      setCurrentPage(0);
   };
   const lastPage = () => {
      setCurrentPage(Math.ceil(employee.length / 25) - 1);
   };

   return (
      <div className="employee-paging-control">
         <button
            className="tiny-button employee-paging-button"
            onClick={firstPage}
         >
            <img src={backArrowSvg.toString()} />
            <img src={backArrowSvg.toString()} />
         </button>
         <button className="tiny-button employee-paging-button" onClick={prevPage}>
            <img src={backArrowSvg.toString()} />
         </button>
         <div className="employee-paging-message body-small-regular">
            showing {Math.min(employee.length, currentPage * 25 + 1)}-
            {Math.min((currentPage + 1) * 25, employee.length)} of{' '}
            {employee.length}
         </div>
         <button className="tiny-button employee-paging-button" onClick={nextPage}>
            <img
               src={backArrowSvg.toString()}
               className="employee-paging-arrow-back"
            />
         </button>
         <button className="tiny-button employee-paging-button" onClick={lastPage}>
            <img
               src={backArrowSvg.toString()}
               className="employee-paging-arrow-back"
            />
            <img
               src={backArrowSvg.toString()}
               className="employee-paging-arrow-back"
            />
         </button>
      </div>
   );
}
